var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details"},[_c('breadcrumb'),_c('div',{staticClass:"flex-center"},[_c('div',{staticClass:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.rich_text1768183891132||'暂无内容')}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }